import { useTheme } from '@mui/material';

import {
  AIIcon,
  LlmIcon,
  BlockchainIcon,
} from '@rumblefish/ui/Rumblefish23Theme';

export const ChatbotServicesData = () => {
  const theme = useTheme();
  return {
    servicesData: [
      {
        name: 'Chatbot',
        icon: BlockchainIcon,
        title: 'Custom RAG-BASED chatbot development',
        boxShadow: theme.mixins.cyanGradientTransparent?.boxShadow || '',
        duration: 4,
        floatingY: 7.4,
        description:
          'RAG (Retrieval-Augmented Generation) is an AI framework that combines pre-trained AI language models with information retrieved from an external knowledge base. It significantly improves conversational AI responses by retrieving information relevant to a specific context. RAG-based chatbots are the future of customer support as they are highly customizable, contextual, and applicable to any industry. Our RAG-based chatbot development team will craft a perfect tool for you and your customers.',
      },
      {
        name: 'LLM',
        icon: LlmIcon,
        title: 'Custom LLM-POWERED chatbot development',
        boxShadow: theme.mixins.grapeGradientTransparent?.boxShadow || '',
        duration: 5,
        floatingY: 3,
        description:
          'LLMs are Large Language Models that undergo training on a massive amount of data to understand and generate human-like text. Among dozens of existing LLMs, GPT-4 developed by OpenAI is the most popular one. Some other, lesser-known but also very powerful LLMs are Llama 2 from Meta, Claude 2 from Anthropic, and Gemini by Google. All of them can be used to build customized AI assistants to fulfill specific business requirements. Our AI development team is capable of building an AI chatbot on top of any of those LLMs. If you want to implement a ChatGPT-like assistant to your company, let’s work together!',
      },
      {
        name: 'AI',
        icon: AIIcon,
        title: 'AI chatbot consultancy',
        boxShadow: theme.mixins.purpleGradientTransparent?.boxShadow || '',
        duration: 2,
        floatingY: 4.5,
        description:
          'If you feel like your business could benefit from implementing an AI-powered chatbot but don’t know where to start - we’re here to guide you! We’ll analyze your business case and craft the most effective strategy for your custom AI assistant development process. You can count on us to choose the most suitable development plan for your product or service based on the type of information you’re already processing, your current tech stack, and your resources.',
      },
    ],
  };
};
